import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#127897",
        secondary: "#00897B",
        accent: "#82B1FF",
        accent_light: "#F2F9FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        basic: "#000000",
        basic_secondary: "#424242",
        footer: "#E0E0E0",
        app: "#FFFFFF",
      },
      dark: {
        primary: "#90CAF9",
        secondary: "#00897B",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        basic: "#FFFFFF",
        basic_secondary: "#F5F5F5",
        footer: "#424242",
        app: "#121212",
      },
    },
  },
});
